/*
* Copyright Gregory Coburn 2020-2026, All Rights Reserved, See license for further details
*/
import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Person } from '@src/app/model/person';
import { AbstractHttpService } from '@src/app/shared/abstract-http.service';
import { MessageService } from '@src/app/shared/message.service';
import { catchError, map } from 'rxjs/operators';
import { MailItem } from '@src/app/model/mailMerge';
import { Observable, of } from 'rxjs';
import { uuid } from '@src/app/model/abstract-object';
import { Attachment } from '@src/app/model/attachment';
import { ServiceRequest } from '@src/app/model/serviceRequest';
import { PersonUnitRole } from '@src/app/model/person-unit-role';

@Injectable({
  providedIn: 'root'
})
export class PersonService extends AbstractHttpService {
    protected http = inject(HttpClient);
    protected messageService = inject(MessageService);

    protected get baseUrl() {
        return this.getAjaxPath('people');
    }
  protected cache: Person[];
  protected typeString = 'Person';

    updateRole(pur: PersonUnitRole): Observable<Person> {
        console.log(pur);
        const url = `${this.baseUrl}/${pur.personId}/role/${pur.id}`;
        return this.http.put<Person>(url, pur, this.getSimpleOptions(pur.teamId));
    }

  sendMail(p: Person, subject: string, content: string, mode: 'send' | 'test' | 'attach', attachments: Attachment[] = [], sr?: ServiceRequest, statementUnitId?: string, statementType?: string) : Observable<MailItem>{
    const url = this.baseUrl + '/sendMail/' + p.id;
    return this.http.post<MailItem>(url, {subject, content, attachments, sr: sr?.id, statementUnitId, statementType, mode}, this.getSimpleOptions(p.teamId)).pipe(
        map( x => {
            return x;
        }),
        catchError((error) => {
            this.messageService.showError(error, 'Sending Mail');
            return of(null);
        })
    )
  }

  previewMail(p: Person, subject: string, content: string, sr?: ServiceRequest, statementUnitId?: string, statementType?: string): Observable<{ html: string }> {
    const url = this.baseUrl + '/sendMail/' + p.id;
    const mode = 'preview';
    return this.http.post<{ html: string }>(url, {subject, content, sr: sr?.id, statementUnitId, statementType, mode}, this.getSimpleOptions(p.teamId)).pipe(
        catchError((error) => {
            this.messageService.showError(error, 'Previewing Mail');
            return of(null);
        })
    )
  }

  updateEMail(p: Person, newEmail: string) : Observable<Person>{
    const url = `${this.baseUrl}/${p.id}/${p.revision}/email`;
    const data = {email: newEmail};
    return this.http.put<MailItem>(url, data, this.getSimpleOptions(p.teamId)).pipe(
        map( x => {
            return x;
        }),
        catchError((error) => {
            this.messageService.showError(error, 'Updating Mail');
            return of(null);
        })
    )
  }  

    retire(p: Person): Observable<Person> {
        const url = `${this.baseUrl}/${p.id}/${p.revision}/retire`;
        return this.http.post<Person>(url, { }, this.getSimpleOptions(p.teamId)).pipe(
            catchError((error) => {
                this.messageService.showError(error, 'Retiring Contact');
                return of(null);
            })
        )
    }

    performMerge(remove: Person, mergeIntoId: uuid): Observable<Person> {
        const url = this.baseUrl + '/merge/' + remove.id + '/' + mergeIntoId;
        return this.http.post<MailItem>(url, { }, this.getSimpleOptions(remove.teamId)).pipe(
            map(x => {
                return x;
            }),
            catchError((error) => {
                this.messageService.showError(error, 'Performing Merge');
                return of(null);
            })
        )
    }
}
